module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/436.edd0acf1.png";